import axios from './getAxios';
import { EventRegisterPayloadProps } from './types';

export default async (payload:EventRegisterPayloadProps) => {
  
  const { data } = await axios({
    method: 'POST',
    url: '/api/event-registrations/create',
    data: payload,
  });
  return data;
};
